import React, { type ReactElement } from "react";

import { attachQuestionsToCategories } from "../lib/propHelpers.js";
import type { FAQProps } from "../types.js";
import InteractiveFAQ from "./InteractiveFAQ.js";

/**
 * Support for the [rt-faqs-display] shortcode.
 *
 * @param props The props for the component.
 * @returns The component.
 */
export function FAQ(props: FAQProps): ReactElement {
	const categories = attachQuestionsToCategories(
		props.categories,
		props.questions,
	);
	const categoriesToDisplay = categories.filter(
		(c) =>
			props.cat?.includes(c.id) ||
			(!c.hide_from_list && (!props.cat || props.cat.length === 0)),
	);
	return (
		<div className={props.class} data-testid="faq-container">
			<InteractiveFAQ
				categories={categoriesToDisplay}
				faqProps={props}
				lang={props.lang}
			/>
		</div>
	);
}
